/** --------------------------------------------------
*
*   pages - overview page
*   OVERVIEW PAGE FILTERS
*
*  -------------------------------------------------- */

(($, Drupal, duo) => {

  const BREAKPOINT_FILTERSWITCH_SIDEBAR = '(max-width: 57.5em)';
  let filter_switch_busy = false;
  let filterModal;

  Drupal.behaviors.overview_page_filters = {
    attach: function(context, settings) {
      const self = this;

      // only do the following once:
      $(document, context).once('overview_page_filters').each(function() {
        self.init(context, settings);
      });
    },

    init: function(context, settings) {
      const self = this;

      const $overviewPage = $('.overview-page', context);
      if($overviewPage.length > 0) {

        // filters:
        // --------

        // on a certain breakpoint, we move the filters
        // from their default page location to the filter modal
        // (and vice versa)

        // media query (when to move filter):
        const breakpoint = self.getBreakpoint();
        const mediaQuery = window.matchMedia(breakpoint);
        // -> listen event:
        if (mediaQuery.addEventListener) {
          mediaQuery.addEventListener('change', self.processFilterSwitch);
        } else {
          // --> deprecated "addListener" for browsers that don't support the former:
          mediaQuery.addListener(self.processFilterSwitch);
        }
        self.processFilterSwitch(mediaQuery);

        // setup filter modal:
        // (the modal markup is already on the page)
        // -> create modal:
        filterModal = new duo.Modal({
          modalSelector: '.js-overview-filter-modal',
          toggleButtonClass: 'js-overview-filter-toggle',
          openClass: 'js-overview-filter-visible',
          classHolder: 'html',
          useTransitions: true,
          fixPagePositionWhenOpen: true,
          fixPageClass: 'js-overview-filter-fixed',
          elementToChangeScrollOnFixed: $('.page-wrapper'),
          functionToExecuteOnClose: function() {

            // -> move the filters back to their original position:
            //    (if you enlarge the screen with the filter modal
            //    open, it will stay open - so the filters should
            //    only go back to their original position when closing
            //    the modal)
            self.processFilterSwitch(mediaQuery);
          }
        });

        // add a filter-toggle button to the page:
        const $filterToggleLocation = $(document).find('.overview-page-content-main-filters');
        if($filterToggleLocation.length > 0) {
          const $filterToggleButton = $(`
            <div class="overview-page-filter-toggle-holder">
              <button type="button" class="overview-page-filter-toggle js-overview-filter-toggle">
                <span>${ Drupal.t('Filter') }</span>
              </button>
            </div>
          `);
          $filterToggleLocation.append($filterToggleButton);
        }
      }
    },

    processFilterSwitch: function(mediaQuery) {

      // move the filter-block from one container to another
      // (if the media query matches)

      if(!filter_switch_busy) {
        filter_switch_busy = true;

        const $pageFilterHolder = $(document).find('.js-overview-page-filter');
        const $flyoutFilterHolder = $(document).find('.js-overview-filter-modal-content');

        if (mediaQuery.matches) {
          // move filters to responsive container:
          $pageFilterHolder.find('.js-overview-page-filter-content').appendTo($flyoutFilterHolder);
        } else {
          // move filters to main content:
          $flyoutFilterHolder.find('.js-overview-page-filter-content').appendTo($pageFilterHolder);
          // when the modal container is open, and the filters are moved back
          // to the main content, the modal will be empty;
          // -> close the filter modal in this case:
          if ($('html').hasClass('js-overview-filter-visible')) {
            filterModal.hide();
          }
        }

        filter_switch_busy = false;
      }
    },

    getBreakpoint: function() {
      let breakpointToUse = BREAKPOINT_FILTERSWITCH_SIDEBAR;
      return breakpointToUse;
    }
  };
})(jQuery, Drupal, window.duo = window.duo || {});
